const isProd = true;
export const APP_BASE_URL = isProd ? "https://app.mvrc.co.in" : "https://6fqm9v96-8000.inc1.devtunnels.ms";
export const CLINIC_BASE_URL = "https://mvrc.pythonanywhere.com";
export const clinicToken = "bdb1cd21aed83f83b95b10bbcd3e6b3565ed2d2a";
const loginApiUrl = `${APP_BASE_URL}/clinic/login-react/`;
const medicalLoginApiUrl = `${APP_BASE_URL}/clinic/login-react/`;

// APi for hardware Url  //
const hardwareApi = `${APP_BASE_URL}/clinic/hardware`;
const oldHardwareApi = `${CLINIC_BASE_URL}/api/hardware`;

// APi for HFT Url  //
const hftApi = `${APP_BASE_URL}/lock_devices/hft`;
const hftApiToShow = `${APP_BASE_URL}/lock_devices/hftsystems/`;
// Example: `${APP_BASE_URL}/lock/hftsystems/<ID>`;
const packageInvoice = `${APP_BASE_URL}/invoice/package-invoice/`;
export const packageStats = `${APP_BASE_URL}/invoice/package-stats/`;
const getPackageInvoice = `${APP_BASE_URL}/invoice/package-invoice-machine?page_size=100&machine_name=`;
const getCenterAddress = `${APP_BASE_URL}/invoice/center?name=`;

const consultationInvoiceCRUD = `${APP_BASE_URL}/invoice/consultation-invoice/`;
export const consultationStats = `${APP_BASE_URL}/invoice/consultation-stats/`;
// `${APP_BASE_URL}/invoice/consultation-stats/<center-name>/`;
const medicineCRUD = `${APP_BASE_URL}/invoice/medicine/`;
const medicinePurchases = `${APP_BASE_URL}/invoice/medicine-purchases/`;
const centerAllotMedicine = `${APP_BASE_URL}/invoice/center-allot-medicine/`;
const centersApi = `${APP_BASE_URL}/invoice/centers/`;
const getCenterMedicinesApi = `${APP_BASE_URL}/invoice/center-medicine/?page_size=100&center_name=`;
const barcodeDetailApi = `${APP_BASE_URL}/invoice/medicine-details-by-barcode/?barcode_id=`;
const hftUpdatedViewApi = `${APP_BASE_URL}/lock_devices/hft-updated-view`;

// APi for machine Url  //
const machineUrl = `${APP_BASE_URL}/clinic/machine/`;

// master ji APIs
const masterPatientSearch = `${APP_BASE_URL}/invoice/master-patient-call/`;
const medicineSearch = `${APP_BASE_URL}/invoice/center-medicine-search?`;
const medicineInvoiceCreate = `${APP_BASE_URL}/invoice/medicine-invoice-create/`;
export const medicineStats = `${APP_BASE_URL}/invoice/medicine-stats/`;
const getMedicineInvoice = `${APP_BASE_URL}/invoice/medicine-invoice-center-view?page_size=100&center_name=`;
export const lockDeviceCenterMachine = `${APP_BASE_URL}/lock_devices/center-machines/`;
export const performLockDeviceCenterMachine = `${APP_BASE_URL}/lock_devices/hft/`;
export const invoiceVerificationOtpMachine = `${APP_BASE_URL}/invoice/invoice-verification-otp/`;
export const masterjiOldLockApiGet = `${APP_BASE_URL}/lock_devices/master-ji-lock/`;

export {
    loginApiUrl,
    medicalLoginApiUrl,
    hardwareApi,
    oldHardwareApi,
    hftApi,
    hftApiToShow,
    machineUrl,
    masterPatientSearch,
    packageInvoice,
    getPackageInvoice,
    getCenterAddress,
    consultationInvoiceCRUD,
    medicineCRUD,
    medicinePurchases,
    centerAllotMedicine,
    centersApi,
    getCenterMedicinesApi,
    medicineSearch,
    medicineInvoiceCreate,
    getMedicineInvoice,
    barcodeDetailApi,
    hftUpdatedViewApi,
};
